module.exports = __webpack_public_path__ + "img/swiper-16.508e1c55.png";